import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
	Backdrop,
	Box,
	IconButton,
	Button,
	CircularProgress,
	Container,
	Grid,
} from "@mui/material";
import Swal from "sweetalert2";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { styled } from "@mui/material/styles";
import GetAuth from "../../../GetAuth";
import { ref, child, get, getDatabase, set } from "firebase/database";

const BannerPhoto = () => {
	const [submitting, setSubmitting] = useState(false);
	const [imageLink2, setImageLink2] = useState(null);

	const Input = styled("input")({
		display: "none",
	});

	const [banner, setBanner] = React.useState();
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	useEffect(() => {
		get(child(dbRef, "michelsonaristhyl")).then((snapshot) => {
			setLoad(snapshot.val());
			setBanner(snapshot.val()?.banner);
		});
	}, [dbRef]);

	const [photo, setPhoto] = useState(banner?.imageLink2);
	React.useEffect(() => {
		setPhoto(banner?.imageLink2);
	}, [banner?.imageLink2, submitting]);
	const profilephoto = {
		type: "banner",
		imageLink2: imageLink2 || photo,
		submitTime: new Date().toLocaleString(),
	};

	const update = () => {
		setSubmitting(true);
		set(child(dbRef, "michelsonaristhyl"), { ...load, banner: profilephoto })
			.then(function (response) {
				setSubmitting(false);
				Swal.fire({
					icon: "success",
					title: "Your photo updated Successfully",
					showConfirmButton: false,
					timer: 1500,
				});
				setPhoto(profilephoto?.imageLink2);
				setImageLink2("");
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	const [loading, setLoading] = useState(false);
	const uploadImage = async (e) => {
		const files = e.target.files;
		const data = new FormData();
		data.append("file", files[0]);
		data.append("upload_preset", "Banner");
		setLoading(true);
		const res = await fetch(
			"https://api.cloudinary.com/v1_1/freedomvirtualsolutions/image/upload",
			{
				method: "POST",
				body: data,
			},
		);
		const file = await res.json();
		setImageLink2(file.secure_url);
		setLoading(false);
	};

	return (
		<Container sx={{ pt: 1 }}>
			<Typography
				variant='h4'
				gutterBottom
				className='textColor'
				sx={{ fontWeight: "bold" }}>
				Update Banner Picture
			</Typography>
			<Typography variant='body' gutterBottom className='textColor'>
				Last changed in {banner?.submitTime || "N/A"}
			</Typography>

			<Grid
				container
				spacing={0}
				direction='column'
				alignItems='center'
				justifyContent='center'
				style={{ minHeight: "70vh" }}>
				<img src={photo} style={{ width: "300px" }} alt='' />
				<Box
					display='flex'
					flexDirection='column'
					alignItems='center'
					sx={{ my: 1, mx: "auto" }}>
					<label
						htmlFor='icon-button-file'
						className='bgColor'
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							margin: "0 9px",
							borderRadius: 5,
						}}>
						<Input
							accept='image/*'
							id='icon-button-file'
							type='file'
							onChange={uploadImage}
						/>
						<Typography
							sx={{ my: 2, ml: 2, color: "white" }}
							variant='body1'
							component='div'
							gutterBottom>
							Upload New Banner Picture*
						</Typography>
						<IconButton
							sx={{ mx: 2 }}
							color='primary'
							aria-label='upload picture'
							component='span'>
							<AttachFileIcon fontSize='large' sx={{ fontWeight: "bold" }} />
						</IconButton>
					</label>

					{loading ? (
						<Box sx={{ my: 2 }}>
							<CircularProgress className='textColor' />
						</Box>
					) : (
						<img src={imageLink2} style={{ width: "300px" }} alt='' />
					)}
				</Box>
				{imageLink2 && (
					<Button
						onClick={update}
						variant='contained'
						component='span'
						className='button border'
						sx={{
							my: 1,
							py: 0.5,
							width: "150px",
							border: "2px solid",
							backgroundColor: "transparent",
						}}>
						Update
					</Button>
				)}
			</Grid>
			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={submitting || !load}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Container>
	);
};

export default BannerPhoto;
